import '.cr{font-size:1.125rem;}.ssr-plugin'
import '.fp{line-height:1.75rem;}.ssr-plugin'
import '.bs{text-decoration:none;}.ssr-plugin'
import '.e2{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cr fp"
    >
      {translations.privacySubtitle}{' '}
      <a className="bs e2"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="bs e2"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
